module.exports = __webpack_public_path__ + "static/media/streak-icon.93a01ed2.svg";